import React, { useCallback, useState } from 'react';
import Dropzone from 'react-dropzone';
import { toast } from 'react-toastify';

import { CloudUploadOutlined, CloseOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import ModalActions from 'components/ModalActions';
import Spin from 'components/Spin';
import Truncate from 'v2/components/Shared/TruncateText';
import uploadService from 'v2/services/upload';

interface IProps {
  isModal: boolean;
  open: boolean;
  onClose: any;
  onOk: any;
}

const File = ({ isModal, open, onClose, onOk }: IProps) => {
  const [files, setFiles] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const handleOk = useCallback(() => {
    if (files?.length) {
      if (onOk) {
        const newFile: any = {};
        newFile.method_id = '5';
        newFile.files = files;
        onOk(newFile);
        toast.success('Arquivo(s) adicionado(s) com sucesso!');
        setFiles([]);
      }
    } else {
      toast.warn('Por favor adicione pelo menos um arquivo');
    }
  }, [files, onOk]);

  const onDrop = useCallback((droppedFiles: any) => {
    (async () => {
      try {
        for (let i = 0; i < droppedFiles.length; i++) {
          setLoading(true);
          const result = await uploadService.uploadFile(droppedFiles[i], 'entregar_arquivo');
          droppedFiles[i].upload_id = result.data.upload_id;
          droppedFiles[i].new = true;
        }

        setFiles(prev => prev.concat(droppedFiles));
        setLoading(false);
      } catch (error) {
        toast.error(error);
        setLoading(false);
      }
    })();
  }, []);

  const onRemoveItem = useCallback(
    (index: number, item: any) => {
      const newFiles = [...files];
      newFiles.splice(index, 1);
      setFiles(newFiles);
      toast.success(`Arquivo ${item.name} removido com sucesso!`);
    },
    [files]
  );

  const content = (
    <div>
      {loading ? (
        <div>
          <Spin />
          <p>Por favor, aguarde. Estamos fazendo upload do(s) arquivo(s)...</p>
        </div>
      ) : (
        <div>
          <Dropzone onDrop={onDrop}>
            {({ getRootProps, getInputProps }) => (
              <section>
                <div
                  style={{
                    padding: 24,
                    borderWidth: 2,
                    borderRadius: 2,
                    borderColor: '#eeeeee',
                    borderStyle: 'dashed',
                    backgroundColor: '#fafafa',
                    transition: 'border .3s ease-in-out',
                    height: '100%',
                    textAlign: 'center',
                    color: '#192542',
                    cursor: 'pointer'
                  }}
                  {...getRootProps()}
                >
                  <input {...getInputProps()} id='input-product-delivery-files' />
                  <CloudUploadOutlined style={{ fontSize: 24 }} />
                  <p>Selecione ou arraste um ou mais arquivos aqui.</p>
                  <br />
                  <p style={{ fontSize: '0.9em', fontStyle: 'italic' }}>
                    Para PDFs, o DRM só será aplicado caso o documento não esteja bloqueado ou criptografado com senha
                  </p>
                </div>
              </section>
            )}
          </Dropzone>

          <ul className='list-none p-0'>
            {files?.length
              ? files.map((item: any, index: number) => (
                  <li
                    key={`file-${item.name}`}
                    className='flex items-center justify-between border-b border-gray-200 py-2'
                  >
                    <Truncate count={24} final='...'>
                      {item.name}
                    </Truncate>
                    <Button type='text' icon={<CloseOutlined />} onClick={() => onRemoveItem(index, item)} />
                  </li>
                ))
              : 'Nenhum arquivo adicionado.'}
          </ul>
        </div>
      )}
    </div>
  );

  return (
    <div>
      {isModal ? (
        <ModalActions
          title='Entrega de Conteúdo'
          buttonOk='Salvar'
          open={open}
          onClose={onClose}
          onOk={handleOk}
          loading={loading}
        >
          {content}
        </ModalActions>
      ) : (
        <div className='rounded-sm bg-white shadow-sm'>
          <div className='flex items-center justify-between border-b p-4'>
            <h3 className='font-medium'>Entrega de Conteúdo</h3>
            <Button type='text' icon={<CloseOutlined />} />
          </div>
          <div className='p-4'>{content}</div>
        </div>
      )}
    </div>
  );
};

export default File;
